import ArticlesIndex from "@/components/ArticlesIndex";

export default function Knowledge() {
  return <ArticlesIndex section="knowledge" searchable />;
}
